import React from 'react';
import { Nullable } from 'global';
import { NO_DATA } from 'constants/common';
import { Stack, Tooltip, Typography } from '@mui/material';

interface Props {
  subject: Nullable<string>;
  note: Nullable<string>;
}

export const SubjectCell = ({ subject, note }: Props) => (
  <Stack gap="0.25rem">
    <Typography variant="body2" fontWeight={600} noWrap>
      {subject || NO_DATA}
    </Typography>

    {note && (
      <Tooltip title={note}>
        <Typography variant="caption" color="text.secondary" noWrap sx={{ maxWidth: '16rem' }}>
          {note}
        </Typography>
      </Tooltip>
    )}
  </Stack>
);
